var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationpin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_6834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33344 5.36153C3.33344 7.67983 5.89942 10.213 7.22592 11.3677C7.67466 11.7583 8.32555 11.7583 8.77428 11.3677C10.1008 10.213 12.6668 7.67983 12.6668 5.36153C12.6668 2.77151 10.5774 0.671875 8.0001 0.671875C5.42278 0.671875 3.33344 2.77151 3.33344 5.36153Z",
    stroke: "#DB4B41",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33341 5.48372C9.33341 6.2201 8.73646 6.81706 8.00008 6.81706V6.81706C7.2637 6.81706 6.66675 6.2201 6.66675 5.48372V5.48372C6.66675 4.74734 7.2637 4.15039 8.00008 4.15039V4.15039C8.73646 4.15039 9.33341 4.74734 9.33341 5.48372V5.48372Z",
    stroke: "#DB4B41",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0001 11.7383C2.38084 12.1031 1.33344 12.6841 1.33344 13.3384C1.33344 14.4429 4.3182 15.3384 8.0001 15.3384C11.682 15.3384 14.6668 14.4429 14.6668 13.3384C14.6668 12.6841 13.6194 12.1031 12.0001 11.7383",
    stroke: "#DB4B41",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_6834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationpin);
export default __webpack_public_path__ + "static/media/locationpin.45bbad99017bbb9ad144407db5bf7595.svg";
export { ForwardRef as ReactComponent };